import { render, staticRenderFns } from "./rolesAuthEdit.vue?vue&type=template&id=09d48700&scoped=true&"
import script from "./rolesAuthEdit.vue?vue&type=script&lang=js&"
export * from "./rolesAuthEdit.vue?vue&type=script&lang=js&"
import style0 from "./rolesAuthEdit.vue?vue&type=style&index=0&id=09d48700&lang=less&scoped=true&"
import style1 from "./rolesAuthEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d48700",
  null
  
)

component.options.__file = "rolesAuthEdit.vue"
export default component.exports